<div class="progress-container">
  <div class="progress-bar" [style.width.%]="progress"></div>
</div>
